'use client';

import classNames from 'classnames';
import Link from 'next/link';
import { FC, useState } from 'react';

import type { SubCategoryArticle } from '@/entities/article';

import styles from './articleSubCategoryItem.module.scss';

interface ArticleSubCategoryItemProps {
  value: SubCategoryArticle;
  index: number;
  isActive?: boolean;
  parentDisplayCount?: number;
}

const ArticleSubCategoryItem: FC<ArticleSubCategoryItemProps> = (props) => {
  const { value, index, isActive = false, parentDisplayCount } = props;
  const [isHovered, setIsHovered] = useState(false);
  const showImage = isHovered || isActive;
  const majorCount = parentDisplayCount ?? value.subcategory_sort_order;

  return (
    <div className={styles.container}>
      <div className={styles.container__countBlock}>
        <p className={styles.container__count}>
          {majorCount}.{index}
        </p>
      </div>
      <div className={styles.container__textBlock}>
        <Link
          className={styles.container__link}
          href={`/articles/${value.slug}`}
          title={value.name}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <p className={styles.container__text}>{value.name}</p>
        </Link>
      </div>
      {value.image && (
        <div
          className={classNames(
            'is-desk',
            styles.container__imageWrap,
            showImage && styles.container__imageWrap_visible,
          )}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            alt={value.name}
            className={styles.container__image}
            height={156}
            loading="lazy"
            src={value.image}
          />
        </div>
      )}
    </div>
  );
};

export default ArticleSubCategoryItem;
